import * as React from 'react';
import { Row, Col, Form, Card } from 'antd';
import { fvalue } from '../../form/util';
import { Merchant } from 'src/store';
import { Subscription, Observable } from 'rxjs';
import { DocumentSnapshot } from '@firebase/firestore-types';
import * as firebase from 'firebase/app';
import MerchantTitle from './MerchantTitle';

const FormItem = Form.Item;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

interface Props {
    merchantId?: string | null;
}

interface S {
    merchant?: Merchant;
    status: 'none' | 'loading' | 'notFound' | 'loaded';
}

export default class MerchantSummary extends React.Component<Props, S> {
    subscription: Subscription;

    constructor(props: Props) {
        super(props);

        this.subscription = new Subscription();
        this.state = { status: 'none' };
    }

    componentDidMount() {
        const { merchantId } = this.props;
        this.state = { status: 'loading' };
        const doc$ = new Observable<DocumentSnapshot>(observer => {
            return firebase.firestore()
                .doc(`merchants/${merchantId}`).onSnapshot({
                    next: sn => observer.next(sn),
                    error: err => observer.error(err),
                });
        });

        this.subscription = doc$
            .filter(sn => sn.exists)
            .subscribe(sn => {
                const merchant = sn.data() as Merchant;
                this.setState({ status: 'loaded', merchant });
            });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        const { status, merchant } = this.state;
        const title = merchant ?
            (
                <MerchantTitle
                    title={fvalue(merchant.businessName)}
                    photo={fvalue(merchant.photo)}
                />
            )
            : null;
        if (merchant) {
            return (
                <Card
                    title={title}
                    bordered={true}
                    style={{ marginBottom: 10 }}
                    loading={status === 'loading'}
                >
                    <Row>
                        <Col span={8}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="ID"
                            >
                                <span className="ant-form-text">{fvalue(merchant.id)}</span>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="Contact Name"
                            >
                                <span className="ant-form-text">{fvalue(merchant.contactName)}</span>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="Login Name"
                            >
                                <span className="ant-form-text">{fvalue(merchant.loginUserName)}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="Email"
                            >
                                <span className="ant-form-text">{fvalue(merchant.email)}</span>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="Phone"
                            >
                                <span className="ant-form-text">{fvalue(merchant.phone)}</span>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="Website"
                            >
                                <span className="ant-form-text">{fvalue(merchant.website)}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col span={16}>
                            <FormItem
                                className="summary-box"
                                {...formItemLayout}
                                label="Address"
                            >
                                <span className="ant-form-text">{fvalue(merchant.address)}</span>
                            </FormItem>
                        </Col>
                    </Row> */}
                </Card>
            );
        } else {
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/merchants/forms/MerchantSummary.tsx